var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"bd-radio-8 fb bg-FFFFFF loading-box"},[_c('img',{staticClass:"mr-24 ml-32 rotate",attrs:{"src":require("../assets/images/icon_update.png"),"alt":""}}),_c('p',{staticClass:"content font-30 c-171A1D-56 item-order-1"},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }